import styled from 'styled-components';

export const ToolbarBar = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  background: var(--mantine-color-body);
  border-bottom: 1px solid light-dark(#e9ecef, var(--mantine-color-dark-5));
  position: sticky;
  /* Pinned just below the stepper bar (47px header + 54px stepper = 101px) */
  top: calc(101px + var(--dx-run-band, 0px));
  z-index: 8;
`;

export const LeftSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;

  /* Hide horizontal scrollbar on macOS Chromium / Webkit */
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
`;

export const ToggleWrap = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: light-dark(#495057, var(--mantine-color-dark-1));
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  > input[type='checkbox'] {
    appearance: none;
    width: 32px;
    height: 18px;
    background: light-dark(#ced4da, var(--mantine-color-dark-3));
    border-radius: 999px;
    position: relative;
    transition: background 0.15s ease;
    cursor: pointer;
    margin: 0;
  }
  > input[type='checkbox']::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background: var(--mantine-color-body);
    border-radius: 50%;
    transition: transform 0.15s ease;
  }
  > input[type='checkbox']:checked {
    background: #228be6;
  }
  > input[type='checkbox']:checked::after {
    transform: translateX(14px);
  }
`;
